import { CheckIcon, LockSimpleIcon, XIcon } from '@phosphor-icons/react';

const SHARED = ['Despesas enviadas ao espaço', 'Divisão e quem pagou', 'Orçamento do espaço'];
const PRIVATE = ['Saldos e limites das suas contas', 'Salário e outras receitas', 'Lançamentos fora do espaço', 'Investimentos, metas e conversas com o Link'];

export function SpacePrivacyAside() {
  return <aside className="self-start rounded-2xl border border-border-subtle bg-surface-sunken p-4 text-xs text-text-secondary">
    <h2 className="flex items-center gap-2 font-semibold text-text-primary"><LockSimpleIcon aria-hidden className="size-4 text-primary" />Privado por padrão</h2>
    <p className="mt-2 leading-relaxed">Entrar num espaço não dá acesso a nada seu. Só o que entrar no espaço — por regra ou por envio — aparece para as outras pessoas.</p>
    <ul className="mt-4 space-y-2" aria-label="O que é compartilhado">
      {SHARED.map((text) => <li key={text} className="flex gap-2"><CheckIcon aria-hidden className="mt-0.5 size-3 shrink-0 text-success-text" /><span>{text}</span></li>)}
    </ul>
    <ul className="mt-2 space-y-2" aria-label="O que continua pessoal">
      {PRIVATE.map((text) => <li key={text} className="flex gap-2"><XIcon aria-hidden className="mt-0.5 size-3 shrink-0 text-error-text" /><span>{text}</span></li>)}
    </ul>
  </aside>;
}
